import { OnboardingRouter } from "@/components/Elemnt/Onboarding/OnboardingRouter";
import { useParams } from "react-router";

const OnboardingRouterPage = () => {
  const { appToken = "" } = useParams();
  return <OnboardingRouter appToken={appToken} />;
};

export default OnboardingRouterPage;
